import psfaLogo from '../config/pages/psfa/logo.png';
import type { Tenant } from './tenant-utils';

export const DEFAULT_HEADER_LOGO_SRC = '/images/cod_logo.png';

const tenantLogoSrcByTenant: Partial<Record<Tenant, string>> = {
  psfa: psfaLogo,
};

export const getHeaderLogoSrc = (tenant?: string | null): string => {
  if (!tenant) return DEFAULT_HEADER_LOGO_SRC;
  return tenantLogoSrcByTenant[tenant as Tenant] ?? DEFAULT_HEADER_LOGO_SRC;
};
